module.exports = __webpack_public_path__ + "static/f6-4ceb34f99bf96c9e7f2b56611bed074e.jpeg";